import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyCI5FsF2ef23Gb3sHHxY0ohT6csjc6hcMs",
  authDomain: "trini-tees.firebaseapp.com",
  projectId: "trini-tees",
  storageBucket: "trini-tees.firebasestorage.app",
  messagingSenderId: "938969678284",
  appId: "1:938969678284:web:52b08e9895834c89225d69",
  measurementId: "G-5BT7TXM39Q"
};

const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);
const functions = getFunctions(app);

export { app, analytics, db, auth, storage, functions };
